var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanweifenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.5H10.5V15.5H15.5V2.5Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0L10 2V16L8 13V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20711 0.5L10.2071 1.5H14.7929L13.7929 0.5H9.20711Z",
    fill: "#D9D9D9",
    stroke: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 2.5H2.875V15.5H7.875V2.5Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.375 0L2.375 2V16L0.375 13V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58211 0.5L2.58211 1.5H7.16789L6.16789 0.5H1.58211Z",
    fill: "#D9D9D9",
    stroke: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanweifenge);
export default __webpack_public_path__ + "static/media/sanweifenge.e361ee0229747c74335ff0d80182388e.svg";
export { ForwardRef as ReactComponent };